module.exports = __webpack_public_path__ + "media/images/frontend/question_down-b4894bfca99da12227018fec7e45717d.svg";